import React, {FC} from "react";
import {useKeycloak} from "@react-keycloak/web";
import {
  UnauthenticatedPlaceholder,
  UnauthorizedPlaceholder
} from "@traas/lib/src/components/layout/UnauthenticatedPlaceholder";
import {AuthenticatedLayout, NavigationDefinition} from "@traas/lib/src/components/layout/AuthenticatedLayout";
import config from "../config";
import {useRoles} from "@ventumsoftware/react-toolkit";

export const AuthMiddleware: FC<{children: React.ReactNode, navigation: NavigationDefinition}> = ({children, navigation}) => {
  const {keycloak} = useKeycloak()
  const roles = useRoles()
  if (! keycloak.authenticated) {
    return <UnauthenticatedPlaceholder />
  }
  if (! roles.includes("office")) {
    return <UnauthorizedPlaceholder />
  }
  return <AuthenticatedLayout navigation={navigation} config={config} app={'planning'}>{children}</AuthenticatedLayout>
}
